import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction, color }) => {
  return (
    <Button color={color} onClick={onClickAction} className={classes.button}>
      キャンセル
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
